import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

// ShoppingCart Context
import { ShoppingCartContextProvider } from "./components/ShoppingCartContext"

// Loading Spinner
import "./components/LoadingSpinner.css"

// Route Component Index compontent
const HomePageIndex = React.lazy(() => import("./components/HomePageComponents/HomePageIndex"))
const SingleItemPageIndex = React.lazy(() => import("./components/SingleItemPageComponents/SingleItemPageIndex"))
const CheckoutPageIndex = React.lazy(() => import("./components/CheckoutPageComponents/CheckoutPageIndex"))
const ShoppingCart = React.lazy(() => import("./components/ShoppingCartPage/ShoppingCartIndex"))
const PageNotFound = React.lazy(() => import("./components/PageNotFound"))

function App() {
  
  return (  
    <BrowserRouter>
      <React.Suspense fallback={
        <div className="AppLoadingContainer">
          <div className="loader">Loadig...</div>
        </div>
      }>
        <Switch>
          <ShoppingCartContextProvider>
            <Route exact path="/" component={HomePageIndex} />
            <Route exact path="/item/:id" component={SingleItemPageIndex} />
            <Route exact path="/shoppingcart" component={ShoppingCart} />
            <Route exact path="/checkout" component={CheckoutPageIndex} />
            <Route exact path="/404" component={PageNotFound} />
          </ShoppingCartContextProvider>
        </Switch>
      </React.Suspense>
    </BrowserRouter>
  );
}

export default App;
